import { render, staticRenderFns } from "./OsInputCheckboxGroup.vue?vue&type=template&id=324d577b&scoped=true"
import script from "./OsInputCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./OsInputCheckboxGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d577b",
  null
  
)

export default component.exports